import slug from 'slugify';

/**
 * Converts a string into a URL-friendly slug.
 *
 * @param {string} str - The string to be slugified.
 * @returns {string} - The slugified string.
 */
export const slugify = (str: string) =>
  slug(str, { lower: true, strict: true });
